import { useAuthStore } from '../../stores/auth/auth.store';

// type WithPermissionConfig = {
//   showAccessDenied: boolean
// } | {
//   showDisabled: boolean
// };

const withPermission = (
  WrappedComponent: React.ComponentType<any>,
  module: string,
  permission: string,
  showAccessDenied: boolean
) => {
  return (props: any) => {
    const { user, permisos } = useAuthStore();
    const hasPermission = permisos.some(
      (permiso) => permiso.idModulo === module && permiso.idPermiso === permission
    );

    if (!user || !hasPermission) {
      return showAccessDenied ? (
        <div>El usuario no tiene permiso para acceder a esta sección.</div>
      ) : (
        <></>
      );
    }
    return <WrappedComponent {...props} />;
  };
};

export default withPermission;
